const isBagServiceError = e => e?.name === "BagSdkException";

export default isBagServiceError;
